export const SMART_REPLY_PROPERTY_NAME = 'EntityExtraction/SmartReplyForEmail';
export const SMART_REPLY_DISTINGUISHED_PROPERTY_SET_ID = 'Common';
export const SMART_REPLY_PROPERTY_TYPE = 'String';
